import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Breakpoint } from '@travel-frontend/core';
import { useMemo } from 'react';
import { isMenuTooLong } from '../../../../components/Header/components/DesktopMenu/isMenuTooLong.js';
import { Menu } from '../../../../components/Menu/index.js';
import { MobileMenu } from '../../../../components/MobileMenu/index.js';
export const DesktopMenu = ({
  menuItems
}) => {
  const isMenuDesktopTooLong = useMemo(() => isMenuTooLong(menuItems), [menuItems]);
  return _jsxs(_Fragment, {
    children: [isMenuDesktopTooLong && _jsx(Breakpoint, {
      matches: ['lg'],
      children: _jsx(MobileMenu, {
        config: menuItems
      })
    }), _jsx(Breakpoint, {
      matches: isMenuDesktopTooLong ? ['xl'] : ['xl', 'lg'],
      children: _jsx(Menu, {
        config: menuItems,
        align: "right",
        stretchTexts: false
      })
    })]
  });
};